module.exports = __webpack_public_path__ + "static/media/grid-4.2b07a173.svg";